import { useAuth } from '@/composables/useAuth';
import { isSpecialRank } from '@/utils/UserHelper';

export default defineNuxtRouteMiddleware(() => {
  const { currentUser } = useAuth();

  if (!isSpecialRank(currentUser.value)) {
    return navigateTo('/');
  }
});
